import React from "react";
import { FaBullhorn } from "react-icons/fa";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";

const CurrentNew = () => {
  const setAnnouncement = useContextSelector(AuthContext, (ctx) => {
    return ctx.setAnnouncement;
  });
  const messagelist = useContextSelector(AuthContext, (ctx) => {
    return ctx.messagelist;
  });
  return (
    <div
      onClick={() => setAnnouncement(true)}
      className="marquee-wrapper marquee-clickable"
    >
      <div
        style={{ display: "flex", alignItems: "center" }}
        className="announcement-row"
      >
        <FaBullhorn color="white" size={18} style={{ marginRight: "5px" }} />
        <marquee class="marquee ng-star-inserted">
          <ul
            style={{
              display: "flex",
              width: "fit-content",
              transform: "translate(-205px)",
            }}
          >
            {messagelist?.length > 0 &&
              messagelist?.map((res) => {
                return (
                  <li className="ng-star-inserted">
                    <span>
                      <p>{res?.message}</p>
                    </span>
                  </li>
                );
              })}
          </ul>
        </marquee>
      </div>
    </div>
  );
};

export default CurrentNew;
